import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import r2wc from '@r2wc/react-to-web-component';

const styles = `
<style>
        ::slotted(*) {
          display: block;
          border: solid blue 1px;
          padding: 3px;
        }
        ::slotted(*) span {
          display: block;
          border: solid red 1px;
          padding: 3px;
        }
        ::slotted(* span) {
          display: block;
          border: solid green 1px;
          padding: 3px;
        }
      </style>
`;

const ChatAppComponent = r2wc(App, { style: styles });
customElements.define('chat-app', ChatAppComponent);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
